import projects from './projects.js';
import projectChecklists from './project-checklists.js';
import projectTemplates from './project-templates.js';
import projectChecklistTemplates from './project-checklist-templates.js';

export default [...projects, ...projectChecklists, ...projectTemplates, ...projectChecklistTemplates];
